import { Size, Tabs, TabItem, Popover, PopoverPosition, Button, Classes } from "construct-ui";
import paginationComponent from "../../../components/pagination/pagination.component";
import MultiSelectComponent from "../../../components/multi-select/multi-select.component"
import codeMasterModel from "../../../models/common/code-master.model";
import StoreFixtureMappingModel from "../../../models/planogram/store-fixture-mapping.model";
import ViewBase from "../../view-base.view";
import SelectSiteSearchInputComponent from "../../../components/site/select-site-search-input.component";
import SelectSiteGroupComponent from "../../../components/site/select-site-group.component";
import StoreFixtureMappingUploadDialog from "./components/store-fixture-mapping-upload.dialog";
import StoreBaseTab from './components/store-base.tab.view'
import moment from "moment";
import { formats as FORMATS } from "../../../config/constants";

/**
 * Store Fixture View
 * 
 * View page that displays all Store fixture mappings
 * 
 * @author Molly Liu
 */

export default function StoreFixtureMappingView() {
  ViewBase.call(this);

  const DEFAULT_FILTERS = {
    fixtureName: '',
    shopType: [],
    siteCode: [],
    siteGroup: []
  };

  const DEFAULT_PAGINATION = {
    pageSize: 10,
    pageIndex: 1,
    totalItems: 0
  };

  const tabTiltes = [
    'Store Base',
    // 'Fixture Base'
  ];

  let activeTab = "Store Base";
  let isSelectedAll = false;
  let filters = structuredClone(DEFAULT_FILTERS);
  let currentSearchParams = structuredClone(DEFAULT_FILTERS);
  let pagination = structuredClone(DEFAULT_PAGINATION);

  let shopTypes = [];
  let isFixtureUploadOpen = false;
  let storeBaseMappingList = [];

  let selectedStoreFixtureMapping = [];

  const toQueryParams = (params) => {
    return Object.assign(
      {
        pageSize: pagination.pageSize,
        pageIndex: pagination.pageIndex,
        fixtureName: params.fixtureName,
        shopType: params.shopType.map((x) => x.code),
        siteCode: params.siteCode.map((s) => s.siteId),
        siteGroup: params.siteGroup.map((c) => c.code)
      },
    );
  };

  const handleSearch = (e) => {
    e.preventDefault();
    pagination = structuredClone(DEFAULT_PAGINATION);
    currentSearchParams = structuredClone(filters)
    if (activeTab == "Store Base") {
      getStoreBaseMappingList();
    }
  }

  const getStoreBaseMappingList = () => {
    this.showLoading();
    
    // Reset selection
    isSelectedAll = false;
    selectedStoreFixtureMapping = [];
    
    StoreFixtureMappingModel.getStoreBaseMappingList(toQueryParams(currentSearchParams))
      .then((result) => {
        if (result.data) {
          storeBaseMappingList = result.data;
          pagination.pageIndex = result.pageIndex;
          pagination.pageSize = result.pageSize;
          pagination.totalItems = result.total;
        }
      })
      .catch((error) => {
        this.handleError(error)
      })
      .finally(() => {
        this.hideLoading();
      })
  }

  const getShopTypes = () => {
    codeMasterModel.getByCategoryV2({ category: 'ShopType' })
      .then((result) => {
        shopTypes = result
      })
      .catch((error) => {
        this.handleError(error);
      })
  }

  const downloadStoreBaseMappingList = () => {
    this.showLoading();
    // pagination = structuredClone(DEFAULT_PAGINATION);
    // currentSearchParams = structuredClone(filters)
    const params = {
      siteCode: selectedStoreFixtureMapping,
      siteGroup: [],
      shopType: []
    }
    const File_Name = `Store_Mapping_${moment(new Date()).format(FORMATS.apiDateFormat)}.xlsx`
    StoreFixtureMappingModel.downloadStoreBaseMapping(params, File_Name)
      .catch((error => {
        this.handleError(error);
      }))
      .finally(() => {
        this.hideLoading();
      })
  }

  const downloadStoreBasePPT = () => {
    if (selectedStoreFixtureMapping.length > 20) {
      this.showErrorMessage(this.getText("EM00000827", "Due to system limitions, you can only download data for up to 20 stores."));
      return false;
    }
    this.showLoading();
    const params = {
      siteCode: selectedStoreFixtureMapping,
      siteGroup: [],
      shopType: []
    }
    const File_Name = `Store-Images-${moment(new Date()).format(FORMATS.apiDateFormat)}.ppt`
    StoreFixtureMappingModel.downloadStoreBasePPT(params, File_Name)
      .catch((error => {
        this.handleError(error);
      }))
      .finally(() => {
        this.hideLoading();
      })
  }

  const clearFilter = () => {
    filters = structuredClone(DEFAULT_FILTERS);
    pagination = structuredClone(DEFAULT_PAGINATION);
  }

  const openFixtureUploadModal = () => {
    isFixtureUploadOpen = true;
  }

  const closeFixtureUploadModal = () => {
    isFixtureUploadOpen = false;
  }

  const selectAllChanged = (e) => {
    if (e.target.checked) {
      isSelectedAll = true;
      storeBaseMappingList.map(s => {
        if (!selectedStoreFixtureMapping.includes(s.storeCode)) {
          selectedStoreFixtureMapping.push(s.storeCode);
        }
      })
    } else {
      isSelectedAll = false;
      selectedStoreFixtureMapping.splice(0, selectedStoreFixtureMapping.length);
    }
    m.redraw();
  }

  const selectMapping = (storeCode) => {
    if (selectedStoreFixtureMapping.includes(storeCode)) {
      return
    }
    selectedStoreFixtureMapping.push(storeCode);
  }

  const deselectMapping = (storeCode) => {
    if (selectedStoreFixtureMapping.includes(storeCode)) {
      isSelectedAll = false;
      selectedStoreFixtureMapping.splice(selectedStoreFixtureMapping.indexOf(storeCode), 1)
    }
  }

  const checkboxClickEvent = (storeCode, isChecked) => {
    if (isChecked) {
      selectMapping(storeCode);
    } else {
      deselectMapping(storeCode);
    }
  }

  const content = [
    m('p', 'Due to system limitions, you can only download data for up to 20 stores.'),
    m('.col-12.d-flex.justify-content-end',
      m(Button, {
        class: Classes.POPOVER_DISSMISS,
        label: this.getText("LT00000021", "Close"),
        size: 'xs'
      }),
      m(Button, {
        class: "ms-2",
        label: this.getText("LT00000492", 'Download'),
        size: 'xs',
        intent: "primary",
        onclick: downloadStoreBasePPT,
      })
    )
  ];

  return {
    oninit: () => {
      getShopTypes();
      getStoreBaseMappingList();
    },
    view: () => {
      return [
        /* SEARCH */
        m('.card.mb-3',
          m('.card-body',
            m('form.needs-validation[novalidate].row.g-2', { onsubmit: handleSearch },
              m('.col-md-3.col-lg-3.position-relative',
                m('label.form-label', this.getText("LT00000071", "Site")),
                m(SelectSiteSearchInputComponent, {
                  multiple: true,
                  selectedItems: filters.siteCode,
                  onSelect: (s) => {
                    // console.log('siteCode===>', s)
                    filters.siteCode = s;
                  }
                }),
              ),
              m('.col-md-3.col-lg-3.position-relative',
                m('label.form-label', this.getText("LT00000072", "Site Group")),
                m(SelectSiteGroupComponent, {
                  selectedItems: filters.siteGroup,
                  onChange: (g) => {
                    filters.siteGroup = g;
                  }
                }),
              ),
              m(".col-md-3.col-lg-3.position-relative",
                m("label.form-label", this.getText("LT00001200", "Shop Type")),
                m(MultiSelectComponent, {
                  items: shopTypes,
                  selectedItems: filters?.shopType,
                  filterable: false,
                  onSelect: (selectedTypes) => {
                    filters.shopType = selectedTypes;
                  }
                })
              ),
              m('.col-md-3.col-lg-3.position-relative',
                m('label.form-label[for="fixtureNameInput"]', this.getText('LT00001197', 'Image Name')),
                m('input#fixtureNameInput', {
                  class: 'form-control form-control-bg',
                  placeholder: this.getText('LT00001197', 'Image Name'),
                  type: 'text',
                  value: filters.fixtureName,
                  onchange: (e) => { filters.fixtureName = e.target.value }
                })
              ),

              m('.col-12.d-flex.justify-content-end.gap-2',
                m('button.btn.btn-primary[type="submit"]', this.getText("LT00000001", "Search")),
                m('button.btn.btn-white',
                  {
                    onclick: () => {
                      clearFilter();
                    }
                  },
                  this.getText("LT00000031", "Clear")
                )
              )
            )
          )
        ),

        m('.d-flex.justify-content-between.align-items-center.gap-3',
          m('.flex-shrink-0.d-flex.align-items-center', { style: 'padding-left: 12px;' },
            m('.form-check',
              m('input.form-check-input#select-all-mapping[type=checkbox]', {
                checked: isSelectedAll,
                onchange: selectAllChanged,
                disabled: storeBaseMappingList.length === 0
              }),
              m('label.form-check-label[for=select-all-mapping]', this.getText("LT00000077", "Select all"))
            ),
          ),

          // BUTTON
          m('.row.gy-2.mb-3',
            m('.col-12.d-flex.justify-content-end',
              m(Popover, {
                style: { "width": "280px" },
                content: content,
                position: PopoverPosition.BOTTOM,
                closeOnEscapeKey: true,
                closeOnContentClick: true,
                closeOnOutsideClick: true,
                hasArrow: true,
                interactionType: "click-trigger",
                trigger: m('button.btn.btn-primary.me-2', {
                  disabled: selectedStoreFixtureMapping.length === 0
                },
                  m('i.bi.bi-file-earmark-arrow-down-fill'),
                  this.getText('LT00001226', 'Download PPT')),
              }),
              m('button.btn.btn-primary.me-2', {
                onclick: downloadStoreBaseMappingList,
                disabled: selectedStoreFixtureMapping.length === 0
              },
                m('i.bi.bi-file-earmark-arrow-down-fill'),
                this.getText('LT00001227', 'Download Mapping')),

              m('button.btn.btn-primary', {
                onclick: openFixtureUploadModal,
                // disabled: storeBaseMappingList.length === 0
              },
                m('i.bi.bi-file-earmark-arrow-up-fill'),
                this.getText('LT00001228', 'Upload Mapping')),
            ),
          ),
        ),
        /* LIST */
        m('.card',
          m('.card-body',
            { style: { "padding-top": "0px" } },
            m('.row.mb-3',
              m(Tabs, {
                align: "left",
                bordered: false,
                fluid: false,
                size: Size.XS
              }, [
                tabTiltes.map(item => m(TabItem, {
                  label: item,
                  active: activeTab === item,
                  loading: false,
                  onclick: () => activeTab = item
                }))
              ])
            ),
            activeTab == 'Store Base' &&
            m('.d-flex.flex-column.gap-3.mb-3',
              storeBaseMappingList && storeBaseMappingList.length > 0
                ? storeBaseMappingList.map((mapping, index) =>
                  m(StoreBaseTab, {
                    key: index + mapping.storeCode,
                    isSelected: isSelectedAll || selectedStoreFixtureMapping.includes(mapping.storeCode),
                    onCheckboxChange: (storeCode, isChecked) => checkboxClickEvent(storeCode, isChecked),
                    mapping: mapping,
                  })
                )
                : m('.text-center.my-5', this.getText("EM00000141", "No records found."))
            ),
            m('.col-12', m(paginationComponent,
              {
                currentPage: pagination.pageIndex,
                pageSize: pagination.pageSize,
                totalItems: pagination.totalItems,
                onPageChanged: (pageIndex) => {
                  pagination.pageIndex = pageIndex;
                  getStoreBaseMappingList();
                },
                onPageSizeChanged: (_, pageSize) => {
                  pagination.pageIndex = DEFAULT_PAGINATION.pageIndex
                  pagination.pageSize = pageSize;
                  getStoreBaseMappingList();
                }
              }
            ))
          )
        ),
        isFixtureUploadOpen &&
        m(StoreFixtureMappingUploadDialog,
          {
            isOpen: isFixtureUploadOpen,
            onClose: closeFixtureUploadModal
          }
        ),
        this.getBaseViews()
      ];
    }
  };
}
